import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import {
  clearDisableConnectorResponse,
  disableConnector,
  fetchConnections,
  generatePublicChatbotSnippet,
  getOauth2ConnectionLink
} from "../../../../redux/actions/connectionActions";
import { clearDisableIntentResponse, clearReEnableIntentResponse } from "../../../../redux/actions/intentsActions";
import { pushMessage } from "../../../../redux/actions/commonActions";
import history from "../../../../history";
import { openURLInNewWindow } from "../../../../common/utils";
import Highlight from "react-highlight";
import DisableConnectorDialog from "../ConnectionDialog/disableConnectorDialog";
import EmbedConnectorDialog from "../ConnectionDialog/embedConnectorDialog";

class DropDownMenu extends React.Component {
  state = {
    openCofnirmDisableDialog: false,
    embedPromptOpened: false,
    cofnirmDisableDialog: false
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { disableConnectorResponse } = this.props;
    if (disableConnectorResponse && prevProps.disableConnectorResponse !== disableConnectorResponse) {
      this.handleConnectorDisabledResponse(disableConnectorResponse);
    }
  }

  handleConnectorDisabledResponse = apiResponse => {
    const { clearDisableConnectorResponse, pushMessage } = this.props;
    clearDisableConnectorResponse();
    if (apiResponse.code === 200) {
      pushMessage({
        message: "Connector successfully disabled.",
        type: "success"
      });

      this.props.fetchConnections();
    } else if (apiResponse.code === 403) {
      pushMessage({
        message: "Insufficient permissions for delete action. Contact you administrator for more information.",
        type: "error"
      });
    } else {
      pushMessage({
        message: "Could not disable connector, please try again later",
        type: "error"
      });
    }
  };

  closeDisableConnectorDialog = () => {
    this.setState({ openCofnirmDisableDialog: false });
  };

  confirmDisableConnectorDialog = () => {
    this.setState({ cofnirmDisableDialog: true }, () => this.handleDisableClick());
  };

  handleConfigClick = () => {
    this.props.handleOpenDialog(this.props.currentConnection);
  };

  openEmbedPromptWindow = async () => {
    // make redux action call to get bot properties
    await this.props.generatePublicChatbotSnippet();
    this.setState({ embedPromptOpened: true });
  };

  handleCancelEmbed = () => {
    this.setState({ embedPromptOpened: false });
  };

  handleDisableClick = () => {
    if (!this.state.openCofnirmDisableDialog) {
      this.setState({ openCofnirmDisableDialog: true });
    }

    if (this.state.cofnirmDisableDialog) {
      const { pushMessage, currentConnection, disableConnector } = this.props;

      pushMessage({
        message: "Disabling connector and all related tasks",
        type: "info"
      });

      // Check if there's info about current connection
      if (!currentConnection) {
        // this.setState({ disableConnectorBtnDisabled: false });

        return pushMessage({
          message: "Could not load selected connector",
          type: "error"
        });
      }
      disableConnector(currentConnection);
      this.setState({ openCofnirmDisableDialog: false, cofnirmDisableDialog: false });
    }
  };

  // handleLinkClick = () => {
  //   console.log("LINK click");
  // };

  handleLinkConnector = async () => {
    localStorage.setItem("ConnectionId", this.props.currentConnection.connectionName);
    // enable
    await this.props.getOauth2ConnectionLink(this.props.currentConnection.connectionName);
    if (this.props.connections.latestOAuthRedirectLink.createConnectionStatus !== 200) {
      this.props.pushMessage({
        message: "Error in generating redirect link.",
        type: "error"
      });
    } else {
      openURLInNewWindow(this.props.connections.latestOAuthRedirectLink.oauthRedirectUrl);
    }
  };

  render() {
    return (
      <div>
        <DisableConnectorDialog
          open={this.state.openCofnirmDisableDialog}
          currentConnection={this.props.currentConnection}
          closeDisableConnectorDialog={this.closeDisableConnectorDialog}
          confirmDisableConnectorDialog={this.confirmDisableConnectorDialog}
        />

        <EmbedConnectorDialog
          open={this.state.embedPromptOpened}
          publicChatbotProps={this.props.publicChatbotProps}
          handleCancelEmbed={this.handleCancelEmbed}
        />

        <Menu
          id="simple-menu"
          anchorEl={this.props.anchorEl}
          keepMounted
          open={Boolean(this.props.anchorEl)}
          onClose={this.props.handleCloseMenu}
        >
          {(_.includes(this.props.customConnectors, this.props.currentConnection.connectionName) ||
            ["faq-dev", "faq"].indexOf(this.props.currentConnection.connectionName) >= 0) && (
            <MenuItem onClick={this.handleConfigClick} disabled={!this.props.administrator}>
              Config
            </MenuItem>
          )}
          {this.props.currentConnection.type === "public-rest-api" && (
            <MenuItem onClick={this.openEmbedPromptWindow} disabled={!this.props.administrator}>
              Embed
            </MenuItem>
          )}
          {this.props.displayLink ? <MenuItem onClick={this.handleLinkConnector}>Link</MenuItem> : ""}
          <MenuItem
            onClick={this.handleDisableClick}
            disabled={this.props.botBuildTriggered || !this.props.administrator}
          >
            Disable
          </MenuItem>
        </Menu>
        {this.props.open && this.props.showConnectionDetailsDialog()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    connections: state.connections,
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator",
    publicChatbotProps: state.connections["publicChatbotProps"] ? state.connections["publicChatbotProps"] : {},
    disableConnectorResponse: state.connections.disableConnectorResponse,
    botBuildTriggered: state.intents["botBuildTriggered"] ? state.intents.botBuildTriggered : false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        disableConnector,
        clearDisableConnectorResponse,
        pushMessage,
        fetchConnections,
        getOauth2ConnectionLink,
        generatePublicChatbotSnippet
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropDownMenu);
